<mat-toolbar color="secondary">
  <div>
    <button mat-icon-button (click)="openSidenav()">
      <mat-icon>menu</mat-icon>
    </button>
  </div>
  <div class="logo"></div>
</mat-toolbar>

